import React from 'react';
import { Box, Chip, Divider, Paper, Typography } from '@mui/material';
import { CANCER_TREATMENT_STATUSES, getCancerHistoriesArray, getCancerTypeName } from '../../types/patient';

interface CancerHistorySectionProps {
  cancerHistories: string | null;
}

/**
 * がん疾患歴を表示するセクション
 */
const CancerHistorySection: React.FC<CancerHistorySectionProps> = ({
  cancerHistories
}) => {
  // getCancerHistoriesArrayを使用して一貫した形式でデータを取得
  const histories = getCancerHistoriesArray(cancerHistories);
  return (
    <>
      <Typography variant="h6" gutterBottom>がん罹患歴</Typography>
      <Divider sx={{mb: 2}}/>
      <Paper variant="outlined" sx={{p: 2}}>
        {histories.length === 0 ? (
          <Typography
            variant="body1"
            sx={{
              color: 'text.disabled',
              fontWeight: 'normal',
              fontStyle: 'italic',
              fontSize: '1.1rem',
              whiteSpace: 'pre-line'
            }}
          >
            [未入力]
          </Typography>
        ) : (
          <>
            {histories.map((history, index) => {
              // 表示するがん種類名
              const cancerName = history.cancer_type === 'OTHER' && history.other
                ? history.other
                : getCancerTypeName(history.cancer_type || '');
              // 治療ステータス（存在しない場合は表示しない）
              const hasStatus = !!history.cancer_treatment_status;
              return (
                <Box key={index} mb={index < histories.length - 1 ? 3 : 0}>
                  <Box sx={{display: 'flex', alignItems: 'center', mb: 1}}>
                    <Typography variant="h6" fontWeight="bold" sx={{mr: 1}}>
                      {cancerName || '不明ながん種'}
                    </Typography>
                    {hasStatus && (
                      <Chip
                        label={CANCER_TREATMENT_STATUSES[history.cancer_treatment_status as keyof typeof CANCER_TREATMENT_STATUSES] || '不明'}
                        size="small"
                        sx={{
                          fontWeight: 'bold'
                        }}
                      />
                    )}
                  </Box>
                  <Box ml={2} mb={1}>
                    <Typography variant="body2" component="div">
                      診断時期: <strong>{history.year ? `${history.year}年${history.month ? `${history.month}月` : ''}` : '不明'}</strong>
                    </Typography>
                    {history.stage && (
                      <Typography variant="body2" component="div">
                        <strong>ステージ:</strong> {history.stage}
                      </Typography>
                    )}
                  </Box>
                  {index < histories.length - 1 && <Divider sx={{my: 2}}/>}
                </Box>
              );
            })}
          </>
        )}
      </Paper>
    </>
  );
};
export default CancerHistorySection;
